import { request } from 'api/request';

import type { UserType } from 'pages/permissions/types';

import type { BaseHookProps } from '../type';
import type { ERROR_DATA } from '../type';
import { useQuery } from '@tanstack/react-query';

interface UseGetUserParams extends BaseHookProps {
    id?: string;
}

interface ApiRequestParams {
    selectedUserId?: string;
}

const apiRequest = async ({ selectedUserId }: ApiRequestParams): Promise<UserType> => {
    return await request<UserType>(`admin/users/${selectedUserId}`);
};

export const useGetUser = ({ id }: UseGetUserParams) => {
    return useQuery<UserType, ERROR_DATA<unknown>>({
        queryKey: ['user', id],
        queryFn: () => apiRequest({ selectedUserId: id }),
        refetchOnWindowFocus: false,
        enabled: Boolean(id),
    });
};
